import type {QuoteStatus} from './schemas'

export type QuoteStatusModalAction = {
    label: string
    targetStatus: QuoteStatus
    variant?: 'filled' | 'default'
    destructive?: boolean
}

export type QuoteStatusModalContent = {
    currentDescription: string
    nextDescription: string | null
    actions: QuoteStatusModalAction[]
}

export function getQuoteStatusModalContent(status: QuoteStatus): QuoteStatusModalContent {
    switch (status) {
        case 'draft':
            return {
                currentDescription:
                    'This quote is a draft and has not been sent to the customer yet. Its line items are still editable.',
                nextDescription:
                    'Mark it "Sent" once you have shared it with the customer. Accepting the quote locks its line items and lets you create the order from it.',
                actions: [
                    {label: 'Mark as sent', targetStatus: 'sent', variant: 'default'},
                    {label: 'Accept quote', targetStatus: 'accepted'},
                    {label: 'Void quote', targetStatus: 'voided', destructive: true},
                ],
            }
        case 'sent':
            return {
                currentDescription:
                    'This quote has been sent to the customer. Its line items are still editable.',
                nextDescription:
                    'Accepting the quote locks its line items and lets you create the order from it. Mark it rejected if the customer declined, or void it to cancel it.',
                actions: [
                    {label: 'Accept quote', targetStatus: 'accepted'},
                    {label: 'Mark rejected', targetStatus: 'rejected', destructive: true},
                    {label: 'Void quote', targetStatus: 'voided', destructive: true},
                ],
            }
        case 'accepted':
            return {
                currentDescription:
                    'This quote is accepted. Its line items are locked and you can create the order from it.',
                nextDescription: null,
                actions: [],
            }
        case 'rejected':
            return {
                currentDescription:
                    'This quote was rejected by the customer. Its line items are locked.',
                nextDescription: null,
                actions: [],
            }
        case 'voided':
            return {
                currentDescription: 'This quote has been voided. Its line items are locked.',
                nextDescription: null,
                actions: [],
            }
    }
}
